// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xvbp","top":"styles_top__Rrn59"};